<app-page>
    <app-title>{{ getLocationName() }}</app-title>
    <div align="center"><app-subtitle>{{ 'pending_orders' | translate }}</app-subtitle></div>
    <table align="center" *ngIf="hasUnavailableMenuElements"><tr><td><app-alert>{{ 'warning_unavailable_menu_elements' | translate }}</app-alert></td></tr></table>
    <app-data-table
        [data]="pendingOrders"
        [columns]="ordersColumns"
        [toolbarActions]="toolbarActions"
        (onRowClick)="onRowClick($event)">
    </app-data-table>
</app-page>
